import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=91fcc7a0&scoped=true&"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=91fcc7a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91fcc7a0",
  null
  
)

export default component.exports